export const QUERY_REQUIREMENT = "REQUIREMENT";
export const QUERY_REQUIREMENTS_FULL_LIST = "REQUIREMENTS_FULL_LIST";
export const QUERY_REQUIREMENTS_FULL_LIST_SIZE = "REQUIREMENTS_FULL_LIST_SIZE";
export const QUERY_REQUIREMENTS_LIST = "REQUIREMENTS_LIST";
